// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-header {
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  background: linear-gradient(135deg, #ff843d, #ff5e00);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(255,111,32,0.3);
}
.header-row-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-logo {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}
.header-user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header-row-2 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}
.header-admin-btn {
  font-size: 12px;
  padding: 5px 12px;
  background: rgba(255,255,255,0.25);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 14px;
  cursor: pointer;
}
.header-admin-btn:hover {
  background: rgba(255,255,255,0.35);
}
.header-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255,255,255,0.5);
}
.header-nickname {
  font-size: 13px;
  color: rgba(255,255,255,0.9);
  padding: 4px 10px;
  background: rgba(255,255,255,0.2);
  border-radius: 14px;
}
.header-role-tag {
  font-size: 11px;
  color: #fff;
  padding: 3px 8px;
  background: rgba(255,255,255,0.3);
  border-radius: 8px;
}
.header-profile-btn {
  font-size: 12px;
  padding: 5px 10px;
  background: rgba(255,255,255,0.25);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 14px;
  cursor: pointer;
}
.header-profile-btn:hover {
  background: rgba(255,255,255,0.35);
}
.header-logout-btn {
  font-size: 12px;
  padding: 5px 10px;
  background: rgba(255,255,255,0.15);
  color: rgba(255,255,255,0.85);
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 14px;
  cursor: pointer;
}
.header-logout-btn:hover {
  background: rgba(255,255,255,0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/HeaderBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,WAAW;EACX,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,WAAW;EACX,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC","sourcesContent":[".global-header {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #ff843d, #ff5e00);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 2px 8px rgba(255,111,32,0.3);\n}\n.header-row-1 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.header-logo {\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n}\n.header-user-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.header-row-2 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n.header-admin-btn {\n  font-size: 12px;\n  padding: 5px 12px;\n  background: rgba(255,255,255,0.25);\n  color: #fff;\n  border: 1px solid rgba(255,255,255,0.3);\n  border-radius: 14px;\n  cursor: pointer;\n}\n.header-admin-btn:hover {\n  background: rgba(255,255,255,0.35);\n}\n.header-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid rgba(255,255,255,0.5);\n}\n.header-nickname {\n  font-size: 13px;\n  color: rgba(255,255,255,0.9);\n  padding: 4px 10px;\n  background: rgba(255,255,255,0.2);\n  border-radius: 14px;\n}\n.header-role-tag {\n  font-size: 11px;\n  color: #fff;\n  padding: 3px 8px;\n  background: rgba(255,255,255,0.3);\n  border-radius: 8px;\n}\n.header-profile-btn {\n  font-size: 12px;\n  padding: 5px 10px;\n  background: rgba(255,255,255,0.25);\n  color: #fff;\n  border: 1px solid rgba(255,255,255,0.3);\n  border-radius: 14px;\n  cursor: pointer;\n}\n.header-profile-btn:hover {\n  background: rgba(255,255,255,0.35);\n}\n.header-logout-btn {\n  font-size: 12px;\n  padding: 5px 10px;\n  background: rgba(255,255,255,0.15);\n  color: rgba(255,255,255,0.85);\n  border: 1px solid rgba(255,255,255,0.25);\n  border-radius: 14px;\n  cursor: pointer;\n}\n.header-logout-btn:hover {\n  background: rgba(255,255,255,0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
